'use client';

import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import Button from 'components/buttons/Button';
import ListBlock from 'components/blocks/ListBlock';

import useNotifications from 'hooks/common/useNotifications';

import { ICompletedStepProps } from './CompletedStep.types';

import './CompletedStep.styles.scss';

const { Text } = Typography;

const CompletedStep = ({ codes = [] }: ICompletedStepProps) => {
  const { t } = useTranslation();
  const { notificationApi } = useNotifications();

  const emptyData = !codes || !codes.length;

  const copyResetCodes = async () => {
    try {
      await navigator.clipboard.writeText(codes.join(' '));
      notificationApi.success({ title: t('tooltip.copied') });
    } catch (e) {
      notificationApi.warning({ title: t('error.common.copy') });
    }
  };

  return (
    <div className="np-enable-2fa-comleted-step">
      <Text className="np-enable-2fa-comleted-step__title">{t('modal.twoFAEnable.codes.text')}</Text>

      <ListBlock empty={emptyData} className="np-enable-2fa-comleted-step__list-block">
        <div className="np-enable-2fa-comleted-step__codes">
          {codes.map((code, index) => (
            <Text key={index}>{code}</Text>
          ))}
        </div>
      </ListBlock>

      <Button block size="large" disabled={emptyData} onClick={copyResetCodes}>
        {t('form.button.copy')}
      </Button>
    </div>
  );
};

export default CompletedStep;
